import { LazyLoad } from 'app/utils';

export const UserFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.UserFormPage,
);
